export const money = (n: number | undefined) =>
  (n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export const formatDay = (d: string) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || '');
  if (!m) return d || '—';
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    .toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const STATUS_VARIANTS: Record<string, string> = {
  draft: 'secondary', open: 'primary', paid: 'success', void: 'dark', uncollectible: 'warning',
};
